import { Notifications } from '@mui/icons-material';
import { IconButton,  Badge } from '@mui/material';
import React from 'react'
import { useEffect } from 'react';
import { useAppData } from '../../../../context/AppDataContext';
import essNotificationServices from '../essNotificationServices';
import { useNavigate } from 'react-router-dom';

function EssNotificationBadge() {
    const {unreadCount, setUnreadCount} = useAppData();
    const navigate = useNavigate();
    const getUnreadCount = () =>{
        essNotificationServices.getUnreadCount().then(res=>{
        setUnreadCount(res.count)
        //console.log(res.count);
        }).catch(error=>{
        console.log(error);
        })
    }

    const handleNotificationsClick = () =>{
         navigate("/notifications");
    }

    useEffect(()=>{
        getUnreadCount();
    },[])
    return (
        <IconButton color="inherit" onClick={handleNotificationsClick}>
			<Badge badgeContent={unreadCount} color="secondary">
				<Notifications />
			</Badge>
		</IconButton>
    )
}

export default EssNotificationBadge